export default {
      id: "xRoute-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.svg#xRoute",
      toString: function () {
        return this.url;
      }
    }